// extracted by mini-css-extract-plugin
export default {"container":"style_container__4-Y2E"};